import React from 'react';
import {useNavigate} from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <footer className="case-footer">
      <div className="footer-content">
        <div className="company-info">
            <img src="/msl_logo.png" width={140} alt="妙视力Logo"/>
          <h3>杭州深康明视科技有限公司</h3>
          <p>妙视力视觉训练是杭州深康明视科技有限公司研发、生产的视觉功能训练产品。注册资料载明，该产品适用于儿童轻、中度弱视及融合功能不足的治疗。产品将训练内容与游戏、动画形式相结合，便于儿童在家长陪伴下按计划完成训练。</p>
        </div>
        <div className="footer-links">
          <div className="link-column" onClick={() => handleNavigation('/')}>
            <h4>首页</h4>
          </div>
          <div className="link-column" onClick={() => handleNavigation('/product/')}>
            <h4>产品与资质</h4>
          </div>
          <div className="link-column" onClick={() => handleNavigation('/about/brand-and-company/')}>
            <h4>企业与品牌</h4>
          </div>
          <div className="link-column" onClick={() => handleNavigation('/faq/')}>
            <h4>常见问题</h4>
          </div>
          <div className="link-column" onClick={() => handleNavigation('/official-channels/')}>
            <h4>官方渠道</h4>
          </div>
          <div className="link-column" onClick={() => handleNavigation('/download/')}>
            <h4>下载软件</h4>
          </div>
        </div>
      </div>
      <div className="footer-divider"></div>
      <div className="copyright">
        <p>
          <a href="https://beian.miit.gov.cn/" className="icp-link" target="_blank" rel="noopener noreferrer">浙ICP备2025194012号-1</a>
          <span>浙网药信备字〔2026〕00151号</span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;